import { ReactNode } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Box, BoxProps, Dialog, IconButton, PaperProps, Typography } from '@mui/material';
import { noop } from 'lodash';

type BaseModalWrapperProps = {
  children: ReactNode | ReactNode[];
  onClose: typeof noop;
  open?: boolean;
  disabledBackDrop?: boolean;
  disabledEscapeKeyDown?: boolean;
  fullScreen?: boolean;
  paperStyle?: Partial<PaperProps['sx']>;
  boxStyle?: BoxProps['sx'];
  maxWidth?: number;
  hideCloseButton?: boolean;
  keepMounted?: boolean;
  title?: string;
};

const BaseModalWrapper = ({
  children,
  onClose,
  open = false,
  disabledBackDrop = false,
  disabledEscapeKeyDown = true,
  fullScreen = false,
  paperStyle = {},
  boxStyle = {},
  maxWidth = 500,
  hideCloseButton = false,
  keepMounted = true,
  title,
}: BaseModalWrapperProps) => {
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (disabledBackDrop && reason === 'backdropClick') return;
    if (disabledEscapeKeyDown && reason === 'escapeKeyDown') return;

    onClose();
  };

  return (
    <Dialog
      sx={{ maxWidth: 'unset' }}
      fullScreen={fullScreen}
      PaperProps={{
        sx: {
          borderRadius: fullScreen ? 0 : '10px',
          margin: fullScreen ? '0px' : '14px',
          padding: '16px',
          maxWidth,
          ...(paperStyle || {}),
        },
      }}
      open={open}
      onClose={handleClose}
      keepMounted={keepMounted}
      closeAfterTransition={false}
      onBackdropClick={(e) => {
        e.preventDefault();
      }}
    >
      <Box sx={{ overflowY: 'auto', ...boxStyle }}>
        {title ? (
          <Box sx={{ display: 'flex', justifyContent: 'space-between', position: 'relative' }}>
            {title && (
              <Typography
                sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                }}
                variant="h4"
              >
                {title}
              </Typography>
            )}
            {!hideCloseButton && (
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  right: 15,
                  transform: 'translateY(-50%)',
                  width: '40px',
                  height: '40px',
                }}
              >
                <IconButton onClick={onClose} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
            )}
          </Box>
        ) : (
          !hideCloseButton && (
            <Box
              sx={{
                position: 'absolute',
                top: 20,
                right: 15,
                width: '40px',
                height: '40px',
              }}
            >
              <IconButton onClick={onClose} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          )
        )}
        {children}
      </Box>
    </Dialog>
  );
};

export default BaseModalWrapper;
